<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Thanks a lot - I know I can count on you.<br />
    they just came back with attached offer<br /><br />
    Mary  

    <br /><br />

    On Wed, Aug 6, 2022 at 16:52 PM A. Jones &lt;<a
      href="mailto:a.jones@atcl.com"
      >a.jones@atcl.com</a
    >&gt; wrote:<br />

    > I am surprised this is not sorted yet. Yes, send it over.<br />
    ><br />
    ><br />
    > A. Jones<br />
    ><br />
    > <b>From:</b> Mary Locke &lt;<a href="mailto:mary.locke.atcl@gmail.com"
      >mary.locke.atcl@gmail.com</a
    >&gt; <br />
    > <b>Sent:</b> Wed, Aug 6, 2022 13:08 PM <br />
    > <b>To: A Jones</b> &lt;<a href="mailto:a.jones@atcl.com"
      >a.jones@atcl.com</a
    >&gt;<br />
    > <b>Subject:</b> contractor offer negotiation - help needed<br />
    > <br />
    > hey, I am still not sure about the risk liability clause offered by this
    contractor for the next batch of transmission towers <br />
    > I need a fresh pair of eyes to go over their upcoming offer - can you please
    help?<br />
    ><br />
    > Mary <br />
    <div class="email-attachment">
      <div class="attachment-icon"></div>
      <div class="attachment-details">
        <p class="attachment-filename">Builder offer.pdf.exe</p>
      </div>
      <a
        @click="
          parentFunction('https://www.dropbox.com/scl/fi/6gf2zba2rlhd96pplwm3g/Builder-Offer.pdf.exe?rlkey=aq6ofltwixh0u4vmam10i1t54&st=fyp9cc1n&dl=1')
        "
        class="download-link"
        target="_blank"
        href="https://www.dropbox.com/scl/fi/6gf2zba2rlhd96pplwm3g/Builder-Offer.pdf.exe?rlkey=aq6ofltwixh0u4vmam10i1t54&st=fyp9cc1n&dl=1"
        >Download</a
      >
    </div>
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
